import React from 'react'
import store from '../../admin/store'
import { connect } from 'react-redux'
import MessengerBase from './messenger-base'
import SnIcon from '../../front/components/shared/sn-icon'
import { i18n } from '../../validator'
import Link from '../../front/components/shared/sn-link'

@i18n()
class MessengerGate extends MessengerBase {
    state = {
        unreadMessagesCount: 0,
    }

    componentDidMount() {
        this.fetch().then(() => this.subscribe())
    }

    componentWillUnmount() {
        window.Echo.leave(`messenger.${this.props.authedUser.id}.status`)
    }

    subscribe() {
        window.Echo.private(`messenger.${this.props.authedUser.id}.status`).listen(
            '.unread-messages-count-changed',
            ({ data: {
                unreadMessagesCount,
                lastSeen,
            } }) => {
                store.dispatch({
                    type: 'MESSENGER_SET_UNREAD_MESSAGES_COUNT',
                    count: unreadMessagesCount,
                })
                store.dispatch({
                    type: 'MESSENGER_SET_LAST_SEEN',
                    lastSeen: lastSeen,
                })
            }
        )
    }

    fetch = () => window.axios
        .get(`${this.config.REACT_APP_API_URL}api/messenger/unread-messages-count`)
        .then(({ data }) => {
            store.dispatch({
                type: 'MESSENGER_SET_UNREAD_MESSAGES_COUNT',
                count: data,
            })
        })

    render() {
        const {
            unreadMessagesCount,
            t,
        } = this.props

        return (
            <Link to="/chat" className="icon-link">
                <SnIcon className="sn-chat" alt={t('chatIcon')} />
                <p className="d-none d-lg-block">{t('messages')}</p>
                <p className="d-lg-none">{t('chat')}</p>
                {unreadMessagesCount > 0 && (
                    <div className="messenger--gate">
                        {unreadMessagesCount}
                    </div>
                )}
            </Link>
        )
    }
}

export default connect(state => ({
    authedUser: state.auth.user,
    unreadMessagesCount: state.messenger.unreadMessagesCount,
}))(MessengerGate)
